import qs from 'qs'
import removeEmptyKeysAndValues from '../removeEmptyKeysAndValues'
import refineSearchState from '../../domain/search/refineSearchState'

export const generateBrowsePageUrlWithSearchState = ({ term, value }) => {
  const searchStateWithoutEmptyKeys = removeEmptyKeysAndValues(
    refineSearchState({
      taxonomy: {
        type: term,
        label: value
      }
    })
  )
  const newSearchStateStringifyed = qs.stringify(searchStateWithoutEmptyKeys)
  return `browse/?${newSearchStateStringifyed}`
}
